module.exports = __webpack_public_path__ + "static/media/EditIcon.e7ca8366.svg";